import { reactSelectNativeStyle } from "@/components/UI/reactSelect";
import React from "react";
import Select from "react-select";

// Shared option shape for the trade (ESID) selector. Label and value are both the esid.
export interface IESIDOption {
  label: string | undefined;
  value: string | undefined;
}

interface ITradeESIDSelect {
  options: IESIDOption[];
  value: IESIDOption | null;
  // eslint-disable-next-line no-unused-vars
  onChange: (option: IESIDOption | null) => void;
  theme?: string;
  placeholder?: string;
  isDisabled?: boolean;
  isClearable?: boolean;
  isSearchable?: boolean;
  isRtl?: boolean;
  name?: string;
}

// Reusable react-select dropdown for picking a trade by ESID.
// Extracted from the Trade Tile so the Swap Curve widget (and any future widget)
// shares one selector instead of duplicating the markup + styling.
const TradeESIDSelect: React.FC<ITradeESIDSelect> = ({
  options,
  value,
  onChange,
  theme,
  placeholder = "Select ESID ...",
  isDisabled = false,
  isClearable = true,
  isSearchable = true,
  isRtl = false,
  name = "tradeESIDSelect",
}) => {
  return (
    // Match the Trade Settings sidebar Trade ID picker: same native style +
    // w-fit/min-w wrapper so the Trade Tile and Swap Curve dropdowns look identical.
    <div className="w-fit min-w-[120px]">
      <Select
        className="basic-single"
        placeholder={placeholder}
        classNamePrefix="select"
        value={value}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isRtl={isRtl}
        styles={reactSelectNativeStyle(theme)}
        isSearchable={isSearchable}
        name={name}
        options={options}
        onChange={(option) => onChange(option as IESIDOption | null)}
        maxMenuHeight={200}
        menuPlacement="auto"
        menuPosition="fixed"
        menuPortalTarget={
          typeof document !== "undefined" ? document.body : undefined
        }
      />
    </div>
  );
};

export default TradeESIDSelect;
